export const drawerStyles = {
  tabBodyWrapper: {
    padding: '15px',
    paddingBottom: '75px',
    marginBottom: '50px',
  },
  card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '15px',
  },
  tabbedHeaderWrapper: {
    width: '100%',
    padding: '10px',
    height: '48px',
    backgroundColor: '#efefef',
  },
  tabbedHeader: {
    textAlign: 'center',
    margin: '8px 0',
  },
};

export const responsive = {
  text: {
    mobile: '16px',
    desktop: '14px',
  },
};
